import React from 'react'

function Frontend() {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Frontend development</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">HTML5</h3>
                        <div className="skills__level">
                            <div className="skill__meater" style={{width:"100px"}}></div>
                        </div>
                    </div>
                </div>
          

            
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">CSS3</h3>
                        <div className="skills__level">
                            <div className="skill__meater" style={{width:"100px"}}></div>
                        </div>
                    </div>
                </div>
           
            
            
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">JavaScript</h3>
                        <div className="skills__level">
                            <div className="skill__meater" style={{width:"100px"}}></div>
                        </div>
                    </div>
                </div>
            

            
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">React</h3>
                        <div className="skills__level">
                            <div className="skill__meater" style={{width:"100px"}}></div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">Angular</h3>
                        <div className="skills__level">
                            <div className="skill__meater" style={{width:"50px"}}></div>
                        </div>
                    </div>
                </div>
       
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">Wordpress</h3>
                        <div className="skills__level">
                            <div className="skill__meater" style={{width:"60px"}}></div>
                        </div>
                    </div>
                </div>
         
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">TypeScript</h3>
                        <div className="skills__level">
                            <div className="skill__meater" style={{width:"40px"}}></div>
                        </div>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">Bootsrap</h3>
                        <div className="skills__level">
                            <div className="skill__meater" style={{width:"40px"}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Frontend